<template>
  <div class="d-flex align-items-center">
    <!-- Notifications Trigger Button -->
    <li class="nav-item nav-icon-item" ref="notificationContainer">
      <a class="nav-link nav-icon-link notification-icon-trigger" @click.stop.prevent="toggleNotification" href="javascript:void(0)" title="Notifications">
        <img src="/app-assets/images/icons/layout/bell.svg" width="18" height="18" class="ficon" alt="Notifications">
      </a>
    </li>

    <!-- Notification Popup -->
    <Teleport to="body">
      <transition name="notif-backdrop">
        <div v-if="showNotification" class="notif-backdrop" @click="closeNotification"></div>
      </transition>
      <transition name="notif-panel">
        <div v-if="showNotification" class="notification-panel" @click.stop>
          <div class="notif-drag-handle d-md-none"></div>
          <div class="notif-header">
            <div class="d-flex align-items-center justify-content-between px-2 pt-2 pb-1">
              <div class="d-flex align-items-center gap-2">
                <img src="/app-assets/images/icons/layout/bell-primary.svg" width="18" height="18" alt="Notifications">
                <h5 class="notif-title mb-0">Notifications</h5>
              </div>
              <button @click="closeNotification" class="notif-close-btn">
                <img src="/app-assets/images/icons/layout/x.svg" width="16" height="16" alt="Close">
              </button>
            </div>
            <div class="notif-tabs px-2">
              <button :class="['notif-tab', { active: activeTab === 'inbox' }]" @click="activeTab = 'inbox'">Inbox</button>
              <button :class="['notif-tab', { active: activeTab === 'recommended' }]" @click="activeTab = 'recommended'">Recommended</button>
            </div>
            <div class="notif-toolbar d-flex align-items-center justify-content-between px-2 py-1">
              <div class="d-flex align-items-center gap-2">
                <button class="notif-tool-btn" title="Mark all read">
                  <img src="/app-assets/images/icons/layout/check.svg" width="15" height="15" alt="Check">
                  <span class="d-none d-sm-inline ms-1 notif-tool-text">Mark all read</span>
                </button>
              </div>
              <button class="notif-tool-btn" title="Filter">
                <img src="/app-assets/images/icons/layout/filter.svg" width="15" height="15" alt="Filter">
                <span class="d-none d-sm-inline ms-1 notif-tool-text">Filter</span>
              </button>
            </div>
          </div>
          <div class="notif-body">
            <div class="notif-empty-state">
              <div class="notif-bell-bg">
                <img src="/app-assets/images/icons/layout/bell-muted.svg" width="36" height="36" alt="No notifications">
              </div>
              <h6 class="notif-empty-title">No notifications yet</h6>
              <p class="notif-empty-sub">We'll let you know when something needs your attention.</p>
            </div>
          </div>
          <div class="notif-footer">
            <a href="javascript:void(0)" class="notif-footer-link">View all notifications</a>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'Notifications',
  setup() {
    const showNotification = ref(false);
    const activeTab = ref('inbox');
    const notificationContainer = ref(null);

    const toggleNotification = () => {
      showNotification.value = !showNotification.value;
    };

    const closeNotification = () => {
      showNotification.value = false;
    };

    const handleClickOutside = (event) => {
      if (showNotification.value) {
        const panel = document.querySelector('.notification-panel');
        const bellLi = notificationContainer.value;
        if (
          (!bellLi || !bellLi.contains(event.target)) &&
          (!panel || !panel.contains(event.target))
        ) {
          showNotification.value = false;
        }
      }
    };

    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      showNotification,
      activeTab,
      notificationContainer,
      toggleNotification,
      closeNotification
    };
  }
};
</script>

<style scoped>
.nav-icon-item { display: flex; align-items: center; }
.nav-icon-link {
  display: flex; align-items: center; justify-content: center;
  width: 38px; height: 38px;
  padding: 0 !important;
  border-radius: 10px;
  color: #6366f1;
  background-color: transparent;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.nav-icon-link:hover {
  background-color: #f3f4f6;
  transform: translateY(-1px);
}
.ficon {
  width: 20px !important;
  height: 20px !important;
  transition: transform 0.2s ease;
}

.notif-backdrop {
  position: fixed; inset: 0; background: rgba(0,0,0,0.35);
  z-index: 9998; display: none;
}
.notif-backdrop-enter-active, .notif-backdrop-leave-active { transition: opacity 0.22s ease; }
.notif-backdrop-enter-from, .notif-backdrop-leave-to { opacity: 0; }
.notif-panel-enter-active { transition: opacity 0.22s ease, transform 0.26s cubic-bezier(0.34,1.1,0.64,1); }
.notif-panel-leave-active  { transition: opacity 0.18s ease, transform 0.2s ease; }
.notification-panel {
  position: fixed; top: 68px; right: 20px;
  width: 400px; min-height: 450px; max-height: calc(100vh - 100px);
  background: #fff; border-radius: 12px;
  box-shadow: 0 12px 48px rgba(0,0,0,0.12), 0 5px 15px rgba(0,0,0,0.08);
  border: 1px solid rgba(0,0,0,0.05);
  z-index: 9999;
  display: flex; flex-direction: column; overflow: hidden;
}
.notif-panel-enter-from { opacity: 0; transform: translateY(-10px) scale(0.97); }
.notif-panel-leave-to   { opacity: 0; transform: translateY(-6px)  scale(0.97); }
.notif-drag-handle { display: none; }
.notif-header { border-bottom: 1px solid #f1f1f5; flex-shrink: 0; }
.notif-title  { font-weight: 700; font-size: 1rem; color: #2d3748; }
.notif-close-btn {
  width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;
  border: none; background: #f1f5f9; border-radius: 50%;
  color: #718096; cursor: pointer; transition: all 0.18s; flex-shrink: 0;
}
.notif-close-btn:hover { background: #e2e8f0; color: #2d3748; }
.notif-tabs { display: flex; border-bottom: 1px solid #f1f1f5; gap: 0; }
.notif-tab {
  flex: 1; border: none; background: none; padding: 8px 12px;
  font-size: 0.85rem; font-weight: 600; color: #718096;
  border-bottom: 2px solid transparent; transition: color 0.18s, border-color 0.18s; cursor: pointer;
}
.notif-tab:hover { color: #4a5568; }
.notif-tab.active { color: #7367f0; border-bottom-color: #7367f0; }
.notif-toolbar { background: #fcfcfd; border-bottom: 1px solid #f1f1f5; }
.notif-tool-btn {
  display: flex; align-items: center; border: none; background: none; color: #94a3b8;
  font-size: 0.78rem; cursor: pointer; padding: 4px 6px;
  border-radius: 6px; transition: background 0.15s, color 0.15s;
}
.notif-tool-btn:hover { background: #edf2f7; color: #4a5568; }
.notif-body {
  flex: 1; overflow-y: auto;
  display: flex; align-items: center; justify-content: center;
  background: #fff;
}
.notif-empty-state { text-align: center; padding: 1.5rem 1rem; }
.notif-bell-bg {
  width: 64px; height: 64px;
  background: linear-gradient(135deg, #f8f9ff 0%, #eef0ff 100%);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 0.75rem;
}
.notif-empty-title { font-weight: 700; color: #2d3748; font-size: 0.9rem; margin-bottom: 0.25rem; }
.notif-empty-sub   { font-size: 0.78rem; color: #a0aec0; margin: 0; line-height: 1.4; }
.notif-footer { border-top: 1px solid #f1f1f5; background: #fff; flex-shrink: 0; }
.notif-footer-link {
  display: block; text-align: center; padding: 10px;
  font-size: 0.82rem; font-weight: 600; color: #7367f0;
  text-decoration: none; transition: background 0.15s;
}
.notif-footer-link:hover { background: #f8f9ff; color: #5e50ee; }

@media (max-width: 767.98px) {
  .notif-backdrop { display: none; }
  .notification-panel {
    top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%; max-height: 100%;
    border-radius: 0; box-shadow: none;
  }
  .notif-panel-enter-from { opacity: 0; transform: translateX(100%); }
  .notif-panel-leave-to   { opacity: 0; transform: translateX(100%); }
  .notif-panel-enter-active { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
  .notif-panel-leave-active  { transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1); }
  .notif-drag-handle { display: none; }
  .notif-tab { padding: 13px 16px; font-size: 0.92rem; }
  .notif-title { font-size: 1.1rem; }
  .notif-footer-link { padding: 14px; font-size: 0.9rem; }
  .notif-close-btn { width: 32px; height: 32px; }
}
</style>
